import axios from '.';

export interface UserSearchResult {
  wwid: number;
  name: string;
  email: string;
  role: string;
}

export const searchUsers = async (
  search: string,
  signal?: AbortSignal,
): Promise<UserSearchResult[]> => {
  const response = await axios.get('/users/search', { params: { search }, signal });
  return response.data;
};
